import { Model } from '@vuex-orm/core';
import Channel from './Channel';
import Episode from './Episode';
import Tag from './Tag';

export default class Search extends Model { // this is a pseudo singleton
  static get entity() {
    return 'searches';
  }

  static fields() {
    return {
      id: this.number(1),
      channel_ids: this.attr([]),
      channels: this.hasManyBy(Channel, 'channel_ids'),
      episode_ids: this.attr([]),
      episodes: this.hasManyBy(Episode, 'episode_ids'),
      tag_ids: this.attr([]),
      tags: this.hasManyBy(Tag, 'tag_ids'),
      _channelsEnded: this.boolean(false),
      _episodesEnded: this.boolean(false),
      _tagsEnded: this.boolean(false),
    };
  }

  static fetch({ keywords, orderBy, lang }) {
    return this.api().get('/api/search', {
      params: { k: keywords, order_by: orderBy, lang: lang },
      dataTransformer: ({ data }) => {
        return { ...data, id: 1 };
      }
    });
  }

  fetchMore({ keywords, type, orderBy }) {
    let typeSingular = type.substring(0, type.length-1);
    let klass = type === 'channels' ? Channel : type === 'episodes' ? Episode : type === 'tags' ? Tag : null;
    if (!klass) { return; }
    let promise = klass.api().get('/api/search', {
      params: { k: keywords, type: type, order_by: orderBy, offset: this[`${typeSingular}_ids`].length },
      dataTransformer: ({ data }) => {
        return data[type];
      }
    });
    promise.then((result) => {
      Search.update({
        where: this.id,

        data(search) {
          if (!result.entities[type] || result.entities[type].length <= 0) {
            search[`_${type}Ended`] = true;
          } else {
            let ids_of_type = result.entities[type].map((item) => item.id);
            search[`${typeSingular}_ids`].push(...ids_of_type);
          }
        },
      });
    });
    return promise;
  }
}
